//******************************************************************************
//
//
//
//  #HEADER
//
//
//
//******************************************************************************

var Header = (function () {
    var $header;
    var delta;
    var headerHeight;
    var threshold = 10;
    var isScroll;
    var scrollTopLast;

    var _addEventListeners = function() {
        $(window).scroll(function(event) {
            isScroll = true;
        });
    };

    var _hasScrolled = function() {
        var scrollTop = $(this).scrollTop();

        if(Math.abs(scrollTopLast - scrollTop) <= delta) return;

        if(scrollTop >= threshold) {
            $header.addClass('-hidden');
        } else {
            $header.removeClass('-hidden');
        }

        scrollTopLast = scrollTop;
    };

    var init = function() {
        $header = $('.c-header');
        delta = 5;
        headerHeight = $header.outerHeight();
        scrollTopLast = 0;

        _addEventListeners();

        setInterval(function() {
            if(isScroll) {
                _hasScrolled();

                isScroll = false;
            }
        }, 250);
    };

    return {
        init: init
    };
})();